import React, { useState, useEffect } from "react";
import Nav from "./Nav";
import axios from "axios";
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { CgPlayListRemove } from "react-icons/cg";
import { MdPlaylistAdd } from "react-icons/md";
import { ImUser, ImUserPlus } from "react-icons/im";
import { useHistory } from "react-router-dom";



function AddService() {
    let history = useHistory();


    const [open, setOpen] = useState(false);
    const [list_of_services, setService] = useState([]);
    const [newService, setNewService] = useState({
        service_description: "",
        duration: null
    });

    const handleInputChange = (event) => {
        event.preventDefault();
        if (event.target.name === "duration") {
            setNewService({
                ...newService, [event.target.name]: parseInt(event.target.value)
            });
        }
        else {
            setNewService({
                ...newService, [event.target.name]: event.target.value
            });
        }
    }

    const InputIsValid = (newService) => {
        let input = {
            isValidated: false,
            message: ""
        }
        if (newService.service_description === "" || newService.duration == null) {
            input.isValidated = false;
            input.message = "Invalid Input";
        }
        else {
            input.isValidated = true;
            input.message = "Service Added Successfully";
        }
        return input;
    }


    const addService = () => {
        if (InputIsValid(newService).isValidated) {
            axios.post(process.env.REACT_APP_BASEURL + process.env.REACT_APP_ADD_SERVICE_URL, newService)
                .then((response) => {
                    setOpen(true);
                })
                .catch(err => {
                    console.log(err);
                })

        }
        else {
            setOpen(true);
        }
    }

    const handleClose = () => {
        if (InputIsValid(newService).isValidated) {
            setOpen(false);
            history.push("/setupService");
        }
        else {
            setOpen(false);
        }
    }

    useEffect(() => {
        axios.get(process.env.REACT_APP_BASEURL + process.env.REACT_APP_SERVICE_LIST_URL)
            .then((response) => {
                setService(response.data);
            })
            .catch(err => {
                console.log(err);
            })

    }, []);


    return (
        <div className="admin-body">
            <Nav
                headerText="ADMIN"
                nav1="Service Setup"
                nav2="Delete Service"
                nav3="Add User"
                nav4="View Users"
                path1="/setupService"
                path2="/removeService"
                path3="/addUser"
                path4="/users"
                icon1={<MdPlaylistAdd />}
                icon2={<CgPlayListRemove />}
                icon3={<ImUserPlus />}
                icon4={<ImUser />}
            />
            <div className="body">
                <div >
                    <div className="body-inner-wrapper">
                        <div className="code-verify-wrapper">
                            <div className="header-container">
                                <h2>ADD SERVICE</h2>
                                <hr />
                            </div>
                            <div className="add-service-container">
                                <div>
                                    <input
                                        type="text"
                                        placeholder="Service Name"
                                        maxLength="30"
                                        className="service-name"
                                        name="service_description"
                                        onChange={handleInputChange}
                                    />
                                </div>
                                <div>
                                    <input className="service-duration" name="duration" placeholder="Service Duration(minutes)" onChange={handleInputChange} />

                                </div>
                                <div>
                                    <button
                                        type="submit"
                                        className="button"
                                        name="submit"
                                        onClick={addService}
                                    >
                                        Submit
                                    </button>
                                </div>
                                <Dialog
                                    open={open}
                                    onClose={handleClose}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                                >

                                    <DialogContent>
                                        <DialogContentText id="alert-dialog-description">
                                            {InputIsValid(newService).message}
                                        </DialogContentText>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button onClick={handleClose} color="primary">
                                            ok
                                        </Button>

                                    </DialogActions>
                                </Dialog>


                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}
export default AddService;